
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useLoginForm } from './useLoginForm';
import { useNavigate, Link } from 'react-router-dom';

interface LoginFormProps {
  savedEditPath: string | null;
  fromPath: string;
}

export const LoginForm: React.FC<LoginFormProps> = ({ 
  savedEditPath,
  fromPath
}) => {
  const { 
    email, 
    setEmail, 
    password, 
    setPassword, 
    isLoading, 
    error, 
    handleSubmit 
  } = useLoginForm(savedEditPath, fromPath);
  const navigate = useNavigate();

  return (
    <form onSubmit={handleSubmit} className="space-y-4 relative">
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="password">Password</Label>
        <Input
          id="password"
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={6}
        />
      </div>

      {error && <p className="text-sm text-red-500">{error}</p>}

      <Button type="submit" className="w-full mt-8" disabled={isLoading}>
        {isLoading ? 'Processing...' : 'Login'}
      </Button>
      <div className="w-full flex justify-center">
        <Link
          to="/reset-password"
          className="mt-1 text-sm underline"
        >
          Forgot Password?
        </Link>
      </div>
      
    </form>
  );
};
